import { render } from "./ViewPoints.vue?vue&type=template&id=f96c4db4&scoped=true"
import script from "./ViewPoints.vue?vue&type=script&lang=js"
export * from "./ViewPoints.vue?vue&type=script&lang=js"

import "@/assets/css/mypage.css?vue&type=style&index=0&id=f96c4db4&scoped=true&lang=css&external"
import "./ViewPoints.vue?vue&type=style&index=1&id=f96c4db4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f96c4db4"]])

export default __exports__